<template>
  <div v-if="$props.item && $props.item.type == 'PDF'">
    <div class="container">
      <div class="row">
        <div class="col-sm pdf-display">
          <pdf-viewer
            :key="$props.item.id"
            :pdfData="this.pdfData"
            @onLastPageVisualized="lastPageVisualized"
            :loading="this.loading"
          >
            <template slot="left-button">
              <b-button
                v-show="$props.item && $props.item.lastStep == false"
                class="my-2 left-button-next"
                :disabled="$props.item && $props.item.status != 'FINISHED'"
                @click="() => onClickNextStep()"
                variant="primary"
              >
                Ir para próxima etapa
              </b-button>
            </template>
          </pdf-viewer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PdfViewer from "../../../components/pdf-viewer/PdfTrainingViewer.vue";
import { getDocument } from "../../../services/training/trainingService.js";

export default {
  props: ["onFinishedStep", "onStartStep", "onNextStep", "item", "training"],
  components: { PdfViewer },
  watch: {
    item: {
      async handler(val) {
        if (val?.type == "PDF") {
          await this.getDocumentHandler();
        }
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.$props.item?.type == "PDF") {
      await this.getDocumentHandler();
    }
  },
  data() {
    return {
      pdfData: null,
      loading: true,
    };
  },
  methods: {
    getPrincipalFile() {
      const file = this.$props.item.filesAdditional.filter(
        (fa) => fa.principal
      )[0];
      return {
        link: file?.link,
        fileName: file?.fileName,
      };
    },
    async getDocumentHandler() {
      this.loading = true;
      await this.$props.onStartStep(this.$props.item);

      try {
        let principalFile = this.getPrincipalFile();
        console.log("principalFile => ", principalFile);
        const base64Data = await getDocument(
          principalFile.link,
          principalFile.fileName
        );
        
        this.pdfData = base64Data.documentBase64;
        this.loading = false;

      } catch (error) {
        console.error('Error loading document:', error);
        this.loading = false;
      }
    },
    async onClickNextStep() {
      await this.$props.onFinishedStep(this.$props.item, true);
      await this.$props.onNextStep();
    },
    async lastPageVisualized() {
      await this.$props.onFinishedStep(this.$props.item, false);
      if (!this.$store.getters.isAdmin) {
        this.$props.item.status = "FINISHED";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.left-button-next {
  margin-right: 40px;
  flex-direction: column;
}
</style>
